import React from 'react';

// Label/value detail rows shared by both product pages (specifications,
// description, and anything else that is a short labelled block).
//
// What an absent value means is the prop:
//   • emptyMode="omit"     — the row goes. BOTH product pages use this since the
//     owner's rule of 2026-10-03: never show a field that has no data.
//   • emptyMode="fallback" — the row stays and prints `fallbackText`. The
//     factory catalog page used this ("contact the supplier for details") until
//     that rule; nothing uses it now.
// Rendering nothing at all when every row is empty keeps the omit mode from
// leaving a stray heading behind.
export default function SpecRows({ rows = [], lang = 'ar', emptyMode = 'omit', fallbackText = '' }) {
  const isAr = lang === 'ar';
  const font = isAr ? 'var(--font-ar)' : 'var(--font-sans)';

  const hasValue = (v) => v !== null && v !== undefined && String(v).trim() !== '';
  // A row carries EITHER a plain `value` or rendered `children` (chips, pills).
  // omit mode must test both — testing `value` alone would silently drop every
  // children-only row, e.g. the customization chips.
  const shown = (Array.isArray(rows) ? rows : [])
    .filter((r) => r && r.label)
    .filter((r) => (emptyMode === 'omit' ? (hasValue(r.value) || !!r.children) : true));

  if (!shown.length) return null;

  const labelStyle = { fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: 4, fontFamily: font };
  const valueStyle = { fontSize: 13.5, color: 'var(--text-secondary)', lineHeight: 1.7, margin: 0, whiteSpace: 'pre-wrap', fontFamily: font };

  return (
    <div style={{ marginBottom: 16 }}>
      {shown.map((r, i) => (
        <div key={r.key || r.label} style={{ marginBottom: i === shown.length - 1 ? 0 : 14 }}>
          <div style={labelStyle}>{r.label}</div>
          {r.children
            ? r.children
            : <p style={valueStyle}>{hasValue(r.value) ? r.value : fallbackText}</p>}
        </div>
      ))}
    </div>
  );
}
